module.exports = __webpack_public_path__ + "static/img/kid-question1.5e57974c.png";